// extracted by mini-css-extract-plugin
module.exports = {"slider":"SliderPills_slider__z2ged","sliderLine":"SliderPills_sliderLine__8_TYF","sliderRange":"SliderPills_sliderRange__T17Hf","sliderButton":"SliderPills_sliderButton__NSNXj"};